import { BffApiCreateItemError, Currencies } from '../../../../types';

import {
  InvoiceAmount,
  InvoicePayerId,
  InvoicePaymentMethods,
  InvoiceDueDate,
  InvoiceID,
  InvoiceCreatedAt,
  InvoiceNotes,
  InvoiceTerms,
  CreateInvoiceCacheKeys
} from '../../invoicesTypes';

import { BillingInfoID } from '../../../billingInfos/billingInfosTypes';

import { useBffCreateQuery } from '../../../common/reactQuery/hooks/useBffCreateQuery';

import { InvoiceBffUrl } from '../../InvoiceBffUrl';
import { CurrencyRateID } from '../../../currencyRates/currencyRatesTypes';

interface CreateInvoiceOptions {
  cacheKeys?: CreateInvoiceCacheKeys;
}

export interface CreateInvoiceInput {
  invoice: {
    amount: InvoiceAmount;
    payerId: InvoicePayerId;
    paymentMethod: InvoicePaymentMethods;
    billingInfoId: BillingInfoID;
    dueDate: InvoiceDueDate;
    notes?: InvoiceNotes;
    terms?: InvoiceTerms;
    selectedCurrency?: Currencies;
    currencyRateId?: CurrencyRateID;
  };
}

export type CreateInvoiceError = BffApiCreateItemError;

interface CreateInvoiceResponseType {
  id: InvoiceID;
  createdAt: InvoiceCreatedAt;
  dueDate: InvoiceDueDate;
  notes?: InvoiceNotes;
  terms?: InvoiceTerms;
  selectedCurrency?: Currencies;
  currencyRateId?: CurrencyRateID;
}

function useCreateInvoice({ cacheKeys }: CreateInvoiceOptions = {}) {
  const { createQuery, createQueryErrorMessage, createQueryLoading } =
    useBffCreateQuery<
      CreateInvoiceInput,
      CreateInvoiceResponseType,
      CreateInvoiceError,
      CreateInvoiceResponseType
    >({ url: InvoiceBffUrl.create(), cacheKeys });

  return {
    createInvoiceLoading: createQueryLoading,
    createInvoiceErrorMessage: createQueryErrorMessage,
    createInvoice: createQuery
  };
}

export default useCreateInvoice;
